export function showMorePopular() {
    const $section = $('.popular-section');
    const $showMoreBtn = $section.find('.button-holder .button');

    $showMoreBtn.on('click', function (e){
        e.preventDefault();
        $(this).closest('.popular-section').find('.popular-listing.hidden').removeClass('hidden');
        $(this).hide();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/showMorePopular.js